import ContentPage, { Section } from "./ContentPage";
import { COMPANY } from "../data/company";

/**
 * A findable contact page with a real address on it.
 *
 * Razorpay's onboarding looks for one, and the previous site had only a support
 * email buried in the footer and in /help. It is deliberately a page of plain
 * facts rather than a form: a form needs a backend endpoint, and this site does
 * not call the API at all -- keeping it that way is what lets ALLOWED_ORIGINS
 * stay at exactly one origin.
 */
export default function Contact() {
  const { legalName, address, gstin, supportEmail, grievanceOfficer, entity } = COMPANY;

  return (
    <ContentPage title="Contact" lead="How to reach us, and who answers.">
      <Section
        heading="Support"
        body={[
          `Email ${supportEmail} for anything about your account, your plan, a payment or a refund.`,
          "We answer within one working day.",
        ]}
      />
      <Section
        heading="Grievance officer"
        body={[
          "Complaints about how your personal data is handled, under the Digital Personal Data Protection Act, 2023:",
          `${grievanceOfficer.name} — ${grievanceOfficer.email}`,
        ]}
      />
      <Section
        heading="Registered address"
        body={[entity, legalName, address, ...(gstin ? [`GSTIN: ${gstin}`] : [])]}
      />
    </ContentPage>
  );
}
